import { useState } from 'react';
import styled from 'styled-components';
import { Button } from 'reactstrap';
import ThinCheckIcon from '../icons/ThinCheckIcon';
import CopyIcon from '../icons/CopyIcon';
import IconContainer from './IconContainer';

const ClickContainer = styled.div`
  &:hover {
    cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  }
`;

const StyledHoverButton = styled(Button)`
  padding: 0;
  ${({ $hoverOnly }) => !$hoverOnly && '&,'}
  &:hover {
    color: var(--overyield-blue);
  }
  &:disabled {
    opacity: 1;
    color: var(--overyield-green);
  }
`;

const ClickToCopyButton = ({
  buttonClassName,
  copyValue,
  hoverOnly, // Whether the copy icon should be blue on hover only, or blue by default
  iconSize,
  children,
  ...props
}) => {
  const [copied, setCopied] = useState(false);
  return (
    <ClickContainer
      $disabled={copied}
      onClick={() => {
        navigator.clipboard.writeText(copyValue);
        // Change button icon, then reset it after 5 seconds
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      }}
      {...props}
    >
      {children}
      <StyledHoverButton
        className={buttonClassName}
        color="link"
        disabled={copied}
        size="sm"
        title="Copy"
        $hoverOnly={hoverOnly}
      >
        <IconContainer iconSize={iconSize}>
          {copied ? <ThinCheckIcon /> : <CopyIcon />}
        </IconContainer>
      </StyledHoverButton>
    </ClickContainer>
  );
};

export default ClickToCopyButton;
